import { render } from "./MScAddModal.vue?vue&type=template&id=0026e6d9&scoped=true&ts=true"
import script from "./MScAddModal.vue?vue&type=script&lang=ts"
export * from "./MScAddModal.vue?vue&type=script&lang=ts"

import "./MScAddModal.vue?vue&type=style&index=0&id=0026e6d9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0026e6d9"]])

export default __exports__